exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".chosePostCheck{display:inline-block;padding-left:100px;font-size:14px}.chosePostCheck .ivu-checkbox-wrapper{font-size:18px}", ""]);

// exports
